/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_AddInputs */

const en_task_requested_documents_add = /** @type {(inputs: Task_Requested_Documents_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a document`)
};

const pt_br2_task_requested_documents_add = /** @type {(inputs: Task_Requested_Documents_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar documento`)
};

/**
* | output |
* | --- |
* | "Add a document" |
*
* @param {Task_Requested_Documents_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_add = /** @type {((inputs?: Task_Requested_Documents_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_add(inputs)
	return pt_br2_task_requested_documents_add(inputs)
});